import { ENV } from 'types/env';

const getEnvAsEnum = (): ENV | undefined => {
    if (isProdEnv) {
        return ENV.PROD;
    }
    if (isWardynskiEnv) {
        return ENV.WARDYNSKI;
    }
    if (isPreliveEnv) {
        return ENV.PRELIVE;
    }
    if (isDemoEnv) {
        return ENV.DEMO;
    }
    if (isTestEnv) {
        return ENV.TEST;
    }
    if (isDevEnv) {
        return ENV.DEV;
    }
    if (isLocalEnv) {
        return ENV.LOCAL;
    }
    return undefined;
};

const isProdEnv = import.meta.env.VITE_ENV === 'production' || import.meta.env.VITE_ENV === 'prod';
const isWardynskiEnv = import.meta.env.VITE_ENV === 'wardynski' || import.meta.env.VITE_ENV === 'wardynski';
export const isSorainenEnv = import.meta.env.VITE_ENV === 'sorainen';
const isPreliveEnv = import.meta.env.VITE_ENV === 'prelive';
const isDemoEnv = import.meta.env.VITE_ENV === 'demo';
const isTestEnv = import.meta.env.VITE_ENV === 'test';
export const isDevEnv = import.meta.env.VITE_ENV === 'dev' || import.meta.env.VITE_ENV === 'development';
export const isLocalEnv = window.location.hostname === 'localhost';
export const isProductionEnv = isProdEnv || isSorainenEnv || isWardynskiEnv;
export const isDevOrLocalEnv = isDevEnv || isLocalEnv;
export const currentEnv = getEnvAsEnum();
